import React, { useContext, useEffect } from 'react'
import { Container } from 'reactstrap'
import { withRouter } from 'react-router-dom'
import { GeneralContext } from '../../context/'
import ProductSampleImagesManager from './components/ProductSampleImagesManager'

const Index = () => {
    const { setBreadcrumb } = useContext(GeneralContext)

    useEffect(() => {
        setBreadcrumb({
            icon: '',
            parent: `Inventario`,
            parentLink: '/products',
            item: `Imágenes utilitarias`
        })
    }, []) // eslint-disable-line

    return (
        <div className="page-content">
            <Container fluid>
                <ProductSampleImagesManager />
            </Container>
        </div>
    )
}

export default withRouter(Index)
